import { Modal } from '@platform/components';
import { navigate } from 'wouter/use-browser-location';
import { REVIEW_MODE_STORAGE_KEY, ReviewModeStorage } from './RejoinPanel';
import { useApplicationLocalStorage } from '../../application/application-hook';

type RejoinSaveAndExitModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};
export const RejoinSaveAndExitModal = (props: RejoinSaveAndExitModalProps) => {
  const { isOpen, closeModal } = props;
  const { clearApplicationData: clearReviewMode } =
    useApplicationLocalStorage<ReviewModeStorage>(REVIEW_MODE_STORAGE_KEY);
  const exit = () => {
    clearReviewMode();
    navigate('/platform/dashboard');
  };
  return (
    <Modal
      variant='dialog'
      title='Almost there!'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Continue review',
        callback: closeModal,
      }}
      secondaryCTA={{
        text: 'Save & exit',
        callback: exit,
      }}
    >
      <div className='flex flex-col gap-4 w-full text-center h-full'>
        <div>The whole review takes under 10 minutes.</div>
        <div>If you exit now, your progress will be saved. Just log back in to continue later.</div>
      </div>
    </Modal>
  );
};
